import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { EMAIL_REGEX } from "@/react/components/OnboardingPage/helpers/constants";
import type { FieldElement as FieldElementType } from "@/react/types/Element";

const MAX_LENGTH_SHORT_FIELD = 255;
const MAX_LENGTH_LONG_FIELD = 65535;
const MIN_LENGTH_NAME = 2;

interface FieldRules {
  maxLength?: {
    value: number;
    message: string;
  };
  minLength?: {
    value: number;
    message: string;
  };
  pattern?: {
    value: RegExp;
    message: string;
  };
  required?: string;
}

export const useFieldElementRules = (element: FieldElementType): FieldRules =>
  useMemo(() => {
    const rules: FieldRules = {};

    switch (element.attributes.field_type) {
      case "contact_email":
        rules.pattern = {
          value: EMAIL_REGEX,
          message: t("settings.forms.errors.valid_email"),
        };
        rules.maxLength = {
          value: MAX_LENGTH_SHORT_FIELD,
          message: t("settings.forms.errors.max_length", {
            max: MAX_LENGTH_SHORT_FIELD,
          }),
        };
        break;

      case "contact_name":
        rules.minLength = {
          value: MIN_LENGTH_NAME,
          message: t("settings.forms.errors.min_length_2"),
        };
        rules.maxLength = {
          value: MAX_LENGTH_SHORT_FIELD,
          message: t("settings.forms.errors.max_length", {
            max: MAX_LENGTH_SHORT_FIELD,
          }),
        };
        break;

      case "short_answer":
        rules.maxLength = {
          value: MAX_LENGTH_SHORT_FIELD,
          message: t("settings.forms.errors.max_length", {
            max: MAX_LENGTH_SHORT_FIELD,
          }),
        };
        break;

      case "long_answer":
        rules.maxLength = {
          value: MAX_LENGTH_LONG_FIELD,
          message: t("settings.forms.errors.max_length", {
            max: MAX_LENGTH_LONG_FIELD,
          }),
        };
        break;
    }

    if (element.attributes.required) {
      rules.required = t("settings.forms.errors.required");
    }

    return rules;
  }, [element]);
